import * as yup from "yup";

import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import {
  ProductProgramScheduleResource,
  productProgramScheduleSchema,
} from "@client/resources/ProductProgramScheduleResource";

export type FetchProgramScheduleProductsParams = {
  programId: number;
  from: string;
  to: string;
};

export type FetchProgramScheduleProductsResponse = ApiResponse<
  ProductProgramScheduleResource[]
>;

export const fetchProgramScheduleProducts = async (
  params: FetchProgramScheduleProductsParams,
): Promise<FetchProgramScheduleProductsResponse> => {
  const response = await fetchData(
    `/dietitian/programs/{program_id}/schedule/products-list`.replace(
      "{program_id}",
      params.programId.toString(),
    ),
    APIMethods.GET,
    undefined,
    mapUrlParams(params),
  );

  return await schema
    .validate(response)
    .catch(
      logFetchValidateError(
        "/dietitian/programs/{program_id}/schedule/products-list",
      ),
    );
};

const mapUrlParams = (params: FetchProgramScheduleProductsParams) => {
  const urlParams = new URLSearchParams();

  urlParams.set("from", params.from);
  urlParams.set("to", params.to);

  return urlParams;
};

const schema = yup.object({
  data: yup.array().of(productProgramScheduleSchema).defined(),
});
